import React, { useState } from "react";
import "./dialog-edit-registry-by-volume.pure.css";
import { useTranslation } from "react-i18next";
import { useForm } from "../../../hooks";

import { Dialog } from "@progress/kendo-react-dialogs";
import { Label } from "@progress/kendo-react-labels";
import { InputsFormPure, FormError, ButtonHLPure } from "../../pures";
import ModalRequst from "../modal-request/modal-requst-pure";

const DialogEditRegistryByVolumePure = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const { t } = useTranslation();
  const {
    toggleDialog,
    dataItem,
    validator,
    handleEditRegister,
    textError,
    pdfFiles,
  } = props;
  const { fileName, email, firstName, lastName } = dataItem;

  const validatorForEdit = {
    email: validator.emailValidator,
    fileName: validator.fileName,
    firstName: validator.nameValidator,
    lastName: validator.nameValidator,
  };

  const {
    form,
    touch,
    validations,
    onHandleChange,
    onHandleTouch,
    onHandleValidate,
    onValidateForm,
  } = useForm({
    fileName,
    email,
    firstName,
    lastName,
  });

  const onChange = (event, validatorForEdit) => {
    const { name, value } = event.target;
    onHandleChange(name, value);
    touch[name] && onHandleValidate(name, value, validatorForEdit);
  };

  const onBlur = (event, validatorForEdit) => {
    const { name, value } = event.target;
    onHandleValidate(name, value, validatorForEdit);
    onHandleTouch(name, value);
  };

  const onHandleSubmit = () => {
    const result = onValidateForm(form, validatorForEdit);
    if (!Object.keys(result).length) {
      setIsLoading(true);
      handleEditRegister(dataItem, form);
      setSuccess(true);

      setTimeout(() => {
        setIsLoading(false);
        setSuccess(false);
        toggleDialog();
      }, 3000);
    }
  };

  const containerGroupButtonsStyles = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "30px",
  };

  return (
    <div>
      <>
        <Dialog onClose={toggleDialog} title={t("dialogEditRegistryByVolume.title")}>
          <ModalRequst
            isLoading={isLoading}
            error={error}
            textError={textError}
            success={success}
          >
            <div className="wrapper">
              <div className="dialog-container">
                <div className="dialog-invitation-form">
                  <div className="section">
                    <Label className="dialog-labels">
                      {t("dialogEditRegistryByVolume.fileName")}
                    </Label>
                    <InputsFormPure
                      type="text"
                      id="fileName"
                      name="fileName"
                      value={form.fileName}
                      onChange={(e) => onChange(e, validator.fileName)}
                      onBlur={(e) => onBlur(e, validator.fileName)}
                      disabled={
                        Object.values(pdfFiles).find(
                          (file) => file.name === form.fileName
                        )
                          ? true
                          : false
                      }
                    />
                    {validations.fileName && (
                      <FormError
                        message={t("dialogEditRegistryByVolume.errorFileName")}
                      />
                    )}
                  </div>
                  <div className="section">
                    <Label className="dialog-labels">
                      {t("dialogEditRegistryByVolume.email")}
                    </Label>
                    <InputsFormPure
                      type="text"
                      id="email"
                      name="email"
                      value={form.email}
                      onChange={(e) => onChange(e, validator.emailValidator)}
                      onBlur={(e) => onBlur(e, validator.emailValidator)}
                    />
                    {validations.email && (
                      <FormError
                        message={t("dialogEditRegistryByVolume.errorEmail")}
                      />
                    )}
                  </div>
                  <div className="section">
                    <Label className="dialog-labels">
                      {t("dialogEditRegistryByVolume.firstName")}
                    </Label>
                    <InputsFormPure
                      type="text"
                      id="firstName"
                      name="firstName"
                      value={form.firstName}
                      onChange={(e) => onChange(e, validator.nameValidator)}
                      onBlur={(e) => onBlur(e, validator.nameValidator)}
                    />
                    {validations.firstName && (
                      <FormError
                        message={t("dialogEditRegistryByVolume.errorFirstName")}
                      />
                    )}
                  </div>
                  <div>
                    <Label className="dialog-labels">
                      {t("dialogEditRegistryByVolume.lastName")}
                    </Label>
                    <InputsFormPure
                      type="text"
                      id="lastName"
                      name="lastName"
                      value={form.lastName}
                      onChange={(e) => onChange(e, validator.nameValidator)}
                      onBlur={(e) => onBlur(e, validator.nameValidator)}
                    />
                    {validations.lastName && (
                      <FormError
                        message={t("dialogEditRegistryByVolume.errorLastName")}
                      />
                    )}
                  </div>
                  <div className="dialogEditRegistryByVolumePure-btns-container">
                    <ButtonHLPure
                      nameBtn={t("button.cancel")}
                      primary={false}
                      onClickBtn={toggleDialog}
                    />
                    <ButtonHLPure
                      nameBtn={t("button.save")}
                      primary={true}
                      onClickBtn={onHandleSubmit}
                    />
                  </div>
                  {/* <div
                    item="true"
                    xs={12}
                    lg={12}
                    md={12}
                    sm={12}
                    es={12}
                    style={containerGroupButtonsStyles}
                  >
                    <span
                      className="cancel-signer"
                      style={{
                        height: "28px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={toggleDialog}
                    >
                      {t("button.cancel")}
                    </span>
                    <span
                      className="accept-dialog"
                      style={{
                        height: "28px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={onHandleSubmit}
                      disabled={isLoading}
                    >
                      {t("button.save")}
                    </span>
                  </div> */}
                </div>
              </div>
            </div>
          </ModalRequst>
        </Dialog>
      </>
    </div>
  );
};

export default DialogEditRegistryByVolumePure;
